import { useState, useEffect, useCallback } from "react";
import { makeApiRequest, apiRoutes } from "constants/apiRoutes";
import { useAuth } from "utilities/auth";

const DEFAULT_PAGINATION = { page: 1, limit: 25, total: 0, totalPages: 1 };

export function useDisputifierMerchants({ filters = {}, page = 1, limit = 25 } = {}) {
  const [merchants, setMerchants] = useState([]);
  const [pagination, setPagination] = useState(DEFAULT_PAGINATION);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user } = useAuth();

  const fetchMerchants = useCallback(async () => {
    if (!user?.id) return;
    setLoading(true);
    setError(null);

    try {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("limit", String(limit));

      for (const [key, val] of Object.entries(filters)) {
        if (val !== undefined && val !== "") params.set(key, val);
      }

      const url = `${apiRoutes.disputifierListMerchants}?${params.toString()}`;
      const res = await makeApiRequest(
        "get",
        url,
        { id: user.id, accessToken: user.accessToken },
        user.companyId
      );

      const body = res?.data || {};
      setMerchants(body.data || []);
      setPagination(body.pagination || DEFAULT_PAGINATION);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [user?.id, user?.accessToken, user?.companyId, page, limit, filters]);

  useEffect(() => {
    fetchMerchants();
  }, [fetchMerchants]);

  return { merchants, pagination, loading, error, refetch: fetchMerchants };
}
